/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CarbonBlackMigrationParams { 
    /**
     * Dry run migration before committing to the RMS.
     */
    dry_run?: boolean;
    cb_orgs?: Array<string>;
}

